import { React, useRef, useState, useEffect } from "react";
import styled, { keyframes } from "styled-components";
import { useHistory, useLocation } from 'react-router-dom';
import moment from "moment";

import FetchModule from '../../../../Share/Network/FetchModule.js';
import CalenderInput from '../../../../../Component/LockerComponent/LockerCalenderInput';
import CountDaysInput from "../../../../../Component/LockerComponent/CountDaysInput.js";
import LockerSelectBox from "../../../../../Component/MemberComponent/LockerSelectBox.js";
import UnitInput from "../../../../../Component/LockerComponent/UnitInput.js";

import PaymentOptionSettingSelectBox from "../../../../../MemberRegistration/Model/PaymentOptionSettingSelectBox.js";
import PaymentOptionCustomInput from "../../../../../MemberRegistration/Component/PaymentOptionCustomInput.js";
import AddPaymentOptionModal from "../../../../../MemberRegistration/Model/AddPaymentOptionModal.js";

import WhiteTrashIcon from '../../../../../image/WhiteTrashIcon.png';

export default function LockerUsageAddModal(props) {
  const {
    memberData,
    recentlyMembership,
    clickLockerData,
    totalPoint,
    memberName,
    lockerRendering,
    onClickExit 
  } = props;

  const history = useHistory();
  const location = useLocation();

  const DefaultPaymentOption = [{ id: 0, name: '현금' }, { id: 0, name: '카드' }, { id: 0, name: '포인트' }];

  const [isLoading, setIsLoading] = useState(false);
  const [isClickedAddPaymentOption, setIsClickedAddPaymentOption] = useState(false);
  const [memberId, setMemberId] = useState(0);
  const [approvalDate, setApprovalDate] = useState(moment());
  const [startDate, setStartDate] = useState(moment());
  const [endDate, setEndDate] = useState(moment());
  const [dayCount, setDayCount] = useState(endDate.diff(startDate, 'days'));
  // const [cardPrice, setCardPrice] = useState(0);
  // const [cashPrice, setCashPrice] = useState(0);
  // const [point, setPoint] = useState(0);
  const [option, setOption] = useState([]);
  const [selectOption, setSelectOption] = useState(undefined);
  const [isHoverPrevMembership, setIsHoverPrevMembership] = useState(false);

  const [paymentOptions, setPaymentOptions] = useState([{ id: 0, name: '현금' }, { id: 0, name: '카드' }, { id: 0, name: '포인트' }]);
  const [selectedPaymentOptions, setSelectedPaymentOptions] = useState([{ id: 0, name: '현금', price: 0 }]);
  const [isEdit, setIsEdit] = useState(false);

  const LockerRef = useRef();
  const ApprovalCalenderRef = useRef();
  const StartCalenderRef = useRef();
  const EndCalenderRef = useRef();

  // Scroll Fixed //
  useEffect(() => {
    document.body.style = `overflow: hidden`;
    return () => document.body.style = `overflow: auto`;
  }, [])

  // MemberId Setting //
  useEffect(() => {
    setMemberId(parseInt(location.pathname.split('/')[4]));
  }, [location])

  // 락커 정보 수정의 경우 //
  useEffect(() => {
    if (clickLockerData === undefined) {
      setIsEdit(false);

      setSelectOption(undefined);
      setSelectedPaymentOptions([{ id: 0, name: '현금', price: 0 }]);

      setStartDate(moment());
      setEndDate(moment());
      setApprovalDate(moment());
    }
    else {
      setIsEdit(true);

      LockerRef.current.setValue({ id: clickLockerData.lockerId, name: clickLockerData.lockerName });
      setSelectOption({ id: clickLockerData.lockerId, name: clickLockerData.lockerName });
      if (clickLockerData.selectedPaymentOptions !== undefined
        && clickLockerData.selectedPaymentOptions.length > 0) {
        setSelectedPaymentOptions(clickLockerData.selectedPaymentOptions);
      }
      else {
        let newSelectedPaymentOptions = [];

        if (clickLockerData.cashPrice !== 0) newSelectedPaymentOptions.push({ id: 0, name: '현금', price: clickLockerData.cashPrice });
        if (clickLockerData.cardPrice !== 0) newSelectedPaymentOptions.push({ id: 0, name: '카드', price: clickLockerData.cardPrice });
        if (clickLockerData.point !== 0) newSelectedPaymentOptions.push({ id: 0, name: '포인트', price: clickLockerData.point });

        setSelectedPaymentOptions(newSelectedPaymentOptions);
      }

      setStartDate(moment(clickLockerData.startDate));
      setEndDate(moment(clickLockerData.endDate));
      setApprovalDate(moment(clickLockerData.approvalDate));
    }
  }, [clickLockerData, option])

  // Locker Data API Call //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postData('locker/available', 'POST');

        if (responseData.status === 200) {
          setOption(responseData.data);
        }
        else if (responseData.status === 401) {
          alert('로그인 후 다시시도하세요');
          history.push('/');
        }
      }
    )();
  }, [])


  // 결제수단 데이터 불러오기 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('payment_option/', 'GET');

        if (responseData.status === 200) {
          let newPaymentOptions = DefaultPaymentOption.concat(responseData.data.paymentOptions);

          setPaymentOptions(newPaymentOptions);
        }
        else if (responseData.status === 401) history.push('/');
      }
    )();
  }, [])

  // EndDate Reset //
  useEffect(() => {
    if (startDate > endDate) {
      alert("사용 종료일이 시작일보다 빠르게 설정할 수 없습니다.");
      setEndDate(startDate);
      return;
    }

    setDayCount(moment(endDate.format('YYYY-MM-DD 23:59:59')).diff(startDate, 'days') + 1);
  }, [startDate, endDate])
  
  // 이전 등록 회원권 정보 뷰 정리 //
  function onCalcPrevSalesInfo(className) {
    if (recentlyMembership === undefined || recentlyMembership.prevSales === undefined || recentlyMembership.prevMemberShip === undefined) return '';

    if (className === 'MembershipName') return recentlyMembership.prevSales.itemName;
    else if (className === 'Date') return moment(recentlyMembership.prevUsage.startDate).format('YY.MM.DD') + ' - ' + moment(recentlyMembership.prevUsage.endDate).format('YY.MM.DD');
  }

  function CalenderClick(className) {
    if (className === 'StartCalender') {
      EndCalenderRef.current.closeCalender();
      ApprovalCalenderRef.current.closeCalender();
    }
    else if (className === 'EndCalender') {
      StartCalenderRef.current.closeCalender();
      ApprovalCalenderRef.current.closeCalender();
    }
    else {
      StartCalenderRef.current.closeCalender();
      EndCalenderRef.current.closeCalender();
    }
  }

  // 적용일수 변환시 //
  function changeDayCount(value) {
    if (value > 0) setEndDate(startDate.clone().add(value - 1, 'days'));
    else if (value === 0) setEndDate(startDate);

    setDayCount(value);
  }

  // 저장하기 버튼 클릭시 //
  function onClickSave() {
    if (isEdit) {
      let lockerId = selectOption.id;
      let usageId = clickLockerData.usageId;

      if (startDate === '') {
        alert('시작일을 선택해 주세요');
        return;
      }
      else if (endDate === '') {
        alert('종료일을 선택해 주세요');
        return;
      }
      else if (memberId === 0 || memberId === undefined) {
        alert('사용할 회원을 선택해주세요');
        return;
      }

      let finalCashPrice = 0;
      let finalCardPrice = 0;
      let finalPoint = 0;

      let finalSelectedPaymentOptions = [];

      for (let i = 0; i < selectedPaymentOptions.length; i++) {
        if (selectedPaymentOptions[i].price !== ''
          && selectedPaymentOptions[i].price !== 0) finalSelectedPaymentOptions.push(selectedPaymentOptions[i]);
      }

      for (let i = 0; i < finalSelectedPaymentOptions.length; i++) {
        if (finalSelectedPaymentOptions[i].paymentOptionId === undefined) {
          finalSelectedPaymentOptions[i].paymentOptionId = finalSelectedPaymentOptions[i].id;
          finalSelectedPaymentOptions[i].id = 0;
        }
        finalSelectedPaymentOptions[i].paymentOptionName = finalSelectedPaymentOptions[i].name;
      }

      for (let i = 0; i < finalSelectedPaymentOptions.length; i++) {
        if (finalSelectedPaymentOptions[i].paymentOptionId === 0) {
          if (finalSelectedPaymentOptions[i].name === '현금') finalCashPrice += parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
          else if (finalSelectedPaymentOptions[i].name === '카드') finalCardPrice += parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
          else finalPoint += parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
        }
      }

      let requestData = {
        usageId: usageId,
        lockerId: lockerId,
        approvalDate: approvalDate.format('YYYY-MM-DDTHH:mm:ss'),
        startDate: startDate.format('YYYY-MM-DDT00:00:00'),
        endDate: endDate.format('YYYY-MM-DDT23:59:59'),
        cardPrice: finalCardPrice,
        cashPrice: finalCashPrice,
        discountPrice: 0,
        point: finalPoint,
        selectedPaymentOptions: finalSelectedPaymentOptions
      }
      
      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('locker/modify', 'POST', requestData);

          if (responseData.status === 200) {
            alert("락커 정보 변경이 완료되었습니다!");
            lockerRendering();
            onClickExit();
          }
          else if (responseData.status === 201) {
            alert('데이터가 존재하지 않습니다.');
            return;
          }
          else if (responseData.status === 202) {
            alert('삭제된 락커는 사용하실 수 없습니다.');
            return;
          }
          else if (responseData.status === 203) {
            alert('사용이 불가능한 락커입니다.');
            return;
          }
          else if (responseData.status === 204) {
            alert('이미 사용중인 락커입니다');
            return;
          }
          else if (responseData.status === 401) {
            alert("로그인 후 사용하세요");
            history.push('/');
          }
        }
      )();
    }
    else {
      if (selectOption === undefined) {
        alert('사용을 시작할 락커를 설정해주세요!');
        return;
      }

      let storeId = parseInt(window.localStorage.getItem('StoreId'));
      let lockerId = selectOption.id;
      let finalCashPrice = 0;
      let finalCardPrice = 0;
      let finalPoint = 0;

      let finalSelectedPaymentOptions = [];

      for (let i = 0; i < selectedPaymentOptions.length; i++) {
        if (selectedPaymentOptions[i].price !== ''
          && selectedPaymentOptions[i].price !== 0) finalSelectedPaymentOptions.push(selectedPaymentOptions[i]);
      }


      for (let i = 0; i < finalSelectedPaymentOptions.length; i++) {
        if (finalSelectedPaymentOptions[i].id === 0) {
          if (finalSelectedPaymentOptions[i].name === '현금') finalCashPrice += parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
          else if (finalSelectedPaymentOptions[i].name === '카드') finalCardPrice += parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
          else finalPoint += parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
        }
      }

      if (startDate === '') {
        alert('시작일을 선택해 주세요');
        return;
      }
      else if (endDate === '') {
        alert('종료일을 선택해 주세요');
        return;
      }
      else if (approvalDate === '') {
        alert('결제일을 선택해 주세요');
        return;
      }
      else if (memberId === 0 || memberId === undefined) {
        alert('사용할 회원을 선택해주세요');
        return;
      }

      let checkStartDate = moment(startDate.format('YYYY-MM-DD') + 'T00:00:00');
      let checkEndDate = moment(endDate.format('YYYY-MM-DD') + 'T23:59:59');

      if (checkEndDate.isBefore(checkStartDate)) {
        alert('회원권 종료일자를 올바르게 입력해주세요');
        return;
      }


      let data = {
        storeId: storeId,
        lockerId: lockerId,
        memberId: memberId,
        startDate: startDate.format('YYYY-MM-DD') + 'T00:00:00',
        endDate: endDate.format('YYYY-MM-DD') + 'T23:59:59',
        approvalDate: approvalDate.format('YYYY-MM-DDTHH:mm:ss'),
        cardPrice: finalCardPrice,
        cashPrice: finalCashPrice,
        point: finalPoint,
        lockerPaymentOptions: finalSelectedPaymentOptions
      }

      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('locker/start', 'POST', data);

          if (responseData.status === 200) {
            alert("락커 등록이 완료되었습니다!");
            lockerRendering();
            onClickExit();
          }
          else if (responseData.status === 204) {
            if (responseData.error === 'Locker Already Using') {
              alert("이미 사용중인 락커입니다.");
              return;
            }
            else if (responseData.error === 'Invalid Using') {
              alert("사용이 불가능한 락커입니다.");
              return;
            }
            else if (responseData.error === 'Invalid User Data') {
              alert("올바르지 않은 회원 정보입니다.");
              return;
            }
          }
          else if (responseData.status === 401) {
            alert("로그인 후 사용하세요");
            history.push('/');
          }
          else {
            alert(responseData.error);
            return;
          }
        }
      )();
    }
  }

  // 결제수단 모달 내에서 결제수단 저장하기 클릭시 //
  function onClickSavePaymentOption(optionName) {
    if (optionName === '') {
      alert('결제수단의 이름을 입력해주세요');
      return;
    }

    if (isLoading) {
      alert('저장을 진행중입니다');
      return;
    }

    setIsLoading(true);

    let requestData = {
      optionName: optionName
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('payment_option/save', 'POST', requestData);

        if (responseData.status === 200) {
          let newPaymentOptions = DefaultPaymentOption.concat(responseData.data.paymentOptions);

          setPaymentOptions(newPaymentOptions);
          setIsLoading(false);
          setIsClickedAddPaymentOption(false);
        }
        else if (responseData.status === 401) history.push('/');
        else {
          alert(responseData.error);
          setIsLoading(false);
        }
      }
    )();
  }

  // 결제 수단 삭제버튼 클릭시 //
  function onClickDeleteOption(paymentOptionId) {
    if (isLoading) {
      alert('삭제를 진행중입니다');
      return;
    }

    setIsLoading(true);

    let requestData = {
      paymentOptionId: paymentOptionId
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('payment_option/delete', 'POST', requestData);

        if (responseData.status === 200) {
          let newPaymentOptions = DefaultPaymentOption.concat(responseData.data.paymentOptions);

          setPaymentOptions(newPaymentOptions);
          setIsLoading(false);
          setIsClickedAddPaymentOption(false);
        }
        else if (responseData.status === 401) history.push('/');
        else {
          alert(responseData.error);
          setIsLoading(false);
        }
      }
    )();
  }
  // 회원권 결제 수단 변경시 //
  function onChangeSelectedPaymentOptions(data, index) {
    let newSelectedPaymentOptions = selectedPaymentOptions.slice();

    newSelectedPaymentOptions[index].id = data.id;
    newSelectedPaymentOptions[index].name = data.name;

    setSelectedPaymentOptions(newSelectedPaymentOptions);
  }

  // 회원권 결제 금액 변경시 //
  function onChangePaymentOptionPrice(value, index) {
    let newSelectedPaymentOptions = selectedPaymentOptions.slice();

    newSelectedPaymentOptions[index].price = value.replaceAll(',', '');

    setSelectedPaymentOptions(newSelectedPaymentOptions);
  }

  // 회원권 결제 수단 추가 버튼 클릭시 //
  function onClickAddPaymentOptions() {
    let newSelectedPaymentOptions = selectedPaymentOptions.slice();

    newSelectedPaymentOptions.push({ id: 0, name: '현금', price: 0 });

    setSelectedPaymentOptions(newSelectedPaymentOptions);
  }

  // 회원권 결제 수단 제거 버튼 클릭시 //
  function onClickDeletePaymentOptions(index) {
    let newSelectedPaymentOptions = selectedPaymentOptions.slice();

    newSelectedPaymentOptions.splice(index, 1);

    setSelectedPaymentOptions(newSelectedPaymentOptions);
  }

  // 결제 옵션 추가 버튼 클릭시 //
  function onClickAdditionOption() {
    setIsClickedAddPaymentOption(true);
  }

  // 활성 회원권 정보 클릭시 //
  function onClickPrevMembership() {
    if (recentlyMembership === undefined || recentlyMembership.prevSales === undefined || recentlyMembership.prevMemberShip === undefined) return '';

    setStartDate(moment(recentlyMembership.prevUsage.startDate));
    setEndDate(moment(recentlyMembership.prevUsage.endDate));
  }

  return (
    <TopLevelWrapper>
      {isClickedAddPaymentOption && <AddPaymentOptionModal onClickSave={onClickSavePaymentOption} onClickExit={() => setIsClickedAddPaymentOption(false)} />}
      <ModalView>
        <InnerWrapper>
          <TitleWrapper>
            {
              isEdit ?
                <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#000000' cursor='default'>{'\"' + memberData.name + '\"' + ' - 락커 정보 수정'}</Text>
                :
                <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#000000' cursor='default'>{'\"' + memberData.name + '\"' + ' - 락커 추가'}</Text>
            }
          </TitleWrapper>
          <DivisionLine marginTop={10} marginBottom={10}/>
          <RecentlyMembershipWrapper>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#000000' cursor='default'>활성 회원권 정보</Text>
            <RecentlyMembershipInfoWrapper>
              <MembershipInfoWrapper>
                <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#000000' cursor='default'>회원권</Text>
                <MembershipNameWrapper 
                  onMouseOver={() => setIsHoverPrevMembership(true)} 
                  onMouseLeave={() => setIsHoverPrevMembership(false)}
                  onClick={onClickPrevMembership}>
                  <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={isHoverPrevMembership ? '#FF8B48' : '#000000'} cursor='pointer'>{onCalcPrevSalesInfo('MembershipName')}</Text>
                </MembershipNameWrapper>
              </MembershipInfoWrapper>
              <MembershipInfoWrapper>
                <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#000000' cursor='default'>기간</Text>
                <MembershipNameWrapper 
                  onMouseOver={() => setIsHoverPrevMembership(true)} 
                  onMouseLeave={() => setIsHoverPrevMembership(false)}
                  onClick={onClickPrevMembership}>
                  <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={isHoverPrevMembership ? '#FF8B48' : '#000000'} cursor='pointer'>{onCalcPrevSalesInfo('Date')}</Text>
                </MembershipNameWrapper>
              </MembershipInfoWrapper>
            </RecentlyMembershipInfoWrapper>
          </RecentlyMembershipWrapper>
          <InputWrapper>
            <IndividualWrapper style={{ zIndex: selectedPaymentOptions.length + 4 }}>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#000000' cursor='default'>락커 선택</Text>
              <LockerSelectBox ref={LockerRef} disabled={isEdit} options={option} changeFn={setSelectOption} />
            </IndividualWrapper>
            <IndividualWrapper>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#000000' cursor='default'>회원 이름</Text>
              <NameBox>
                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#000000' cursor='default'>{memberName}</Text>
              </NameBox>
            </IndividualWrapper>
            <IndividualWrapper style={{ zIndex: selectedPaymentOptions.length + 3 }}>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#000000' cursor='default'>결제일</Text>
              <CalenderInput ref={ApprovalCalenderRef} value={approvalDate} setValue={setApprovalDate} disabled={false} className='ApprovalCalender' clickFn={CalenderClick} placeholder='결제일' width={130} />
            </IndividualWrapper>
            <IndividualWrapper style={{ zIndex: selectedPaymentOptions.length + 2 }}>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#000000' cursor='default'>시작일</Text>
              <CalenderInput ref={StartCalenderRef} value={startDate} setValue={setStartDate} disabled={false} className='StartCalender' clickFn={CalenderClick} placeholder='시작일' width={130} />
            </IndividualWrapper>
            <IndividualWrapper style={{ zIndex: selectedPaymentOptions.length + 1 }}>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#000000' cursor='default'>종료일</Text>
              <CalenderInput ref={EndCalenderRef} value={endDate} setValue={setEndDate} disabled={false} className='EndCalender' clickFn={CalenderClick} placeholder='종료일' width={130} />
            </IndividualWrapper>
            <IndividualWrapper style={{ marginBottom: '10px' }}>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#000000' cursor='default'>적용 일수</Text>
              <UnitInput value={dayCount} setValue={changeDayCount} unit='일' />
            </IndividualWrapper>
            {
              selectedPaymentOptions.map((data, index) => (
                <LayerWrapper
                  key={'SelectedPaymentOptions-' + index}
                  marginTop={0}
                  gap={10}
                  style={{ zIndex: selectedPaymentOptions.length - index }}>
                  <SelectOptionInputWrapper>
                    <PaymentOptionTitleWrapper>
                      <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#000000' cursor='default'>{'결제 수단 ' + (index === 0 ? '' : index + 1)}</Text>
                      {
                        index !== 0 &&
                        <DeleteButton onClick={() => onClickDeletePaymentOptions(index)}>
                          <DeleteIcon src={WhiteTrashIcon} />
                        </DeleteButton>
                      }
                    </PaymentOptionTitleWrapper>
                    <PaymentOptionSettingSelectBox
                      index={index}
                      value={data}
                      setValue={onChangeSelectedPaymentOptions}
                      options={paymentOptions}
                      disabled={paymentOptions.length === 0}
                      width={126}
                      onClickAdditionOption={onClickAdditionOption}
                      onClickDeleteOption={onClickDeleteOption} />
                  </SelectOptionInputWrapper>
                  <RowDivisionLine />
                  <SelectOptionInputWrapper>
                    <PaymentOptionTitleWrapper>
                      <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#000000' cursor='default'>받은 가격</Text>
                      {(data.paymentOptionId === 0 || (data.paymentOptionId === undefined && data.id === 0)) && data.name === '포인트' && <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#6DD49E' cursor='default'>{totalPoint.toLocaleString('ko-KR') + 'P'}</Text>}
                    </PaymentOptionTitleWrapper>
                    <UnitInputWrapper>
                      <PaymentOptionCustomInput
                        index={index}
                        value={(data.price ?? 0).toLocaleString('ko-KR')}
                        setValue={onChangePaymentOptionPrice}
                        placeholder='0'
                        disabled={false}
                        textAlign='right'
                        width={91} />
                      <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#000000' cursor='default'>원</Text>
                    </UnitInputWrapper>
                  </SelectOptionInputWrapper>
                </LayerWrapper>
              ))
            }
            <AddPaymentOptionButton onClick={onClickAddPaymentOptions}>+ 결제 수단 추가</AddPaymentOptionButton>
          </InputWrapper>
          <ButtonWrapper>
            <ExitButton onClick={onClickExit}>취소</ExitButton>
            <SaveButton onClick={onClickSave}>저장하기</SaveButton>
          </ButtonWrapper>
        </InnerWrapper>
      </ModalView>
    </TopLevelWrapper>
  )
}

const startAnimation = keyframes`
	0% { opacity: 0; }
	50% { opacity: 0.5; }
	100% { opacity: 1; }
`;

const TopLevelWrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;

  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  justify-content: center;
  align-items: center;

  z-index: 1000;

  width: 100vw;
  height: 100vh;

  background-color: rgba(0, 0, 0, 0.2);
	
	animation-name: ${startAnimation};
	animation-duration: 0.5s;
	animation-timing-function: ease-out;
`;

const ModalView = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 20px 0px;

  width: 323px;

  border-radius: 10px;
  box-shadow: 0px 40px 50px rgba(0, 0, 0, 0.1);

  background-color: #FFFFFF;

  transition: all 0.3s ease-in-out;
`;

const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 84.9%;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;
`;

const NameBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  padding: 0px 8px 0px 8px;

  width: 114px;
  height: 32px;

  border: 1px solid #B2B2B2;
  border-radius: 5px;
  background-color: #CBCBCB;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  margin-top: 32px;

  width: 100%;

  gap: 10px;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 74px;
  height: 40px;

  border-radius: 5px;
  background-color: #F5F6F8;
  
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: #3E4148;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const SaveButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100px;
  height: 40px;

  border-radius: 5px;
  background-color: #5BD98A;

  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: #FFFFFF;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const RecentlyMembershipWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;

  gap: 10px;
`;

const RecentlyMembershipInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const MembershipInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 46%;

  gap: 4px;
`;

const MembershipNameWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
  height: 20px;

  overflow: hidden;

  &:hover {
    cursor: pointer;
  }
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  gap: 13px;

  width: 100%;

  margin-top: 30px;
`;

const IndividualWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const LayerWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;
  
  margin-top: ${props => props.marginTop}px;

  width: 100%;

  gap: ${props => props.gap}px;
`;

const SelectOptionInputWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 4px;
`;

const UnitInputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;
`;

const DivisionLine = styled.div`
  margin-top: ${props => props.marginTop}px;
  margin-bottom: ${props => props.marginBottom}px;

  width: 100%;
  height: 1px;

  background-color: #B3B3B3;
`;

const RowDivisionLine = styled.div`
  width: 1px;
  height: 54px;

  background-color #B3B3B3;
`;

const AddPaymentOptionButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-top: 20px;

  width: 100%;
  height: 40px;
  
  border-radius: 5px;
  background-color: #F2F2F2;

  font-family: NotoSansKR-Bold;
  font-size: 14px;

  color: #CBCBCB;

  &:hover {
    cursor: pointer;
    color: #FFFFFF;
    background-color #6DD49E;
  }

  transition: all 0.3s ease-in-out;
`;

const DeleteButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 24px;
  height: 18px;

  border-radius: 2px;
  background-color: #EC9393;

  &:hover {
    cursor: pointer;
    background-color: #D92828;
  }

  transition: all 0.3s ease-in-out;
`;

const DeleteIcon = styled.img`
  width: 14px;
  height: 14px;
`;

const PaymentOptionTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  margin: 0 0 0 0;

  color: ${props => props.color};

  &:hover {
    cursor: ${props => props.cursor};
  }

  transition: all 0.3s ease-in-out;
`;